/* eslint-disable react/prop-types */ // TODO: add props
import C3Chart from 'edrolo-style-guide/components/C3Chart';
import Legend from './Legend';
import styles from './styles.scss';

const colors = {
  'Correct': '#A8CB8C',
  'Incorrect': '#EE7860',
};

const getToolTipHTML = (dataPoints, answers, answerOptions) => {
  const answerOptionIndex = dataPoints[0].index;
  const answerOptionKey = answerOptions[answerOptionIndex];
  const description = answers[answerOptionKey];

  const tooltipItems = dataPoints
    .filter((d) => d.value > 0)
    .map((d) => {
      const name = d.name;
      const value = d.value;
      return `
        <div id="tooltip-legend" style="background:${colors[name]};"></div>
        <span>${name}: ${value}</span><br/>`;
    });

  return tooltipItems.length > 0
    ? `
    <div id="the-tooltip">
      <div id="tooltip-description"><strong>${answerOptionKey}</strong>${description}</div>
      ${tooltipItems.join('')}
    </div>`
    : null;
};

export const StackedBarChartMultiChoice = ({
  question,
  solution,
  profileQuestionResponseSummary,
}) => {
  if (!question || !solution || !profileQuestionResponseSummary) {
    return <p>No Data</p>;
  }

  const answers = question.get('answers').reduce(
    (accumulator, answer) => ({
      ...accumulator,
      [answer.get('serial')]: answer.get('text'),
    }),
    {}
  );

  const answerOptions = question
    .get('answers')
    .map((answer) => answer.get('serial'))
    .toJS(); // e.g. ['A', 'B', 'C', 'D'];

  const correctResponseCount = ['Correct'].concat(
    answerOptions.map(
      (answerOption) =>
        profileQuestionResponseSummary.filter(
          (row) => row.get('answer') === answerOption && row.get('correct')
        ).size
    )
  );

  const incorrectResponseCount = ['Incorrect'].concat(
    answerOptions.map(
      (answerOption) =>
        profileQuestionResponseSummary.filter(
          (row) => row.get('answer') === answerOption && !row.get('correct')
        ).size
    )
  );

  const min = 0;
  const max = profileQuestionResponseSummary.size;
  const height = 180;
  const width = 366;

  const data = {
    columns: [correctResponseCount, incorrectResponseCount],
    type: 'bar',
    colors,
    groups: [['Correct', 'Incorrect']],
    order: null,
  };

  const options = {
    axis: {
      x: {
        type: 'category',
        categories: answerOptions,
        tick: {
          outer: false,
        },
      },
      y: {
        min,
        max,
        padding: {
          bottom: 0,
          top: 50, // leave room for the checkmark above correct bar if all students got the question correct.
        },
        tick: {
          values: [min, Math.floor(max / 2), max],
          outer: false,
        },
      },
    },

    grid: {
      y: {
        lines: [{ value: 0 }],
      },
    },

    size: {
      height,
      width,
    },

    legend: {
      show: false,
    },

    tooltip: {
      show: true,
      position: function (data, width, height, element) {
        return { bottom: 0, left: 20 };
      },
      grouped: true,
      horizontal: false,
      contents: function (dataPoints, defaultTitleFormat, defaultValueFormat) {
        return getToolTipHTML(dataPoints, answers, answerOptions);
      },
    },
  };

  return (
    <div className={styles.container}>
      <p className={styles.chartYAxisLabel}>No. of students</p>
      <C3Chart
        data={data}
        options={options}
        className={styles.chartContainer}
      />
      <Legend />
    </div>
  );
};
